var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import classnames from "classnames";
import { Picture } from "../picture/Picture";
import { PreloaderRipple } from "../preloader/ripple/Ripple";
import { zoomCls, zoomContainerCls, zoomContainerDisableCls, zoomContainerZoomedCls, zoomAreaCls, zoomAreaVisibleCls, zoomMapCls, zoomMapInnerCls, zoomMapImageCls, zoomSVGMaskCls, zoomSmallImgCls, zoomLargeImgCls, zoomLargeImgVisibleCls, zoomLargeImageContainerCls, zoomMapOffset, zoomBorderSize } from "./Zoom.less";
var ZOOM_MAX_LEVEL = 2;
var ZOOM_MIN_LEVEL = 1.25;
var ZOOM_LEVEL_STEP = 0.5;
var ZOOM_INIT_LEVEL = 1;
var ZOOM_MAP_SCALE = 10;
var ZOOM_MAP_OFFSET_CORRECTION = parseInt(zoomMapOffset, 10);
function disablePageTouchMove(event) {
  if (event.defaultPrevented !== true) {
    event.preventDefault();
  }
}
__name(disablePageTouchMove, "disablePageTouchMove");
function relativeCoords(e, containerDimensions) {
  return {
    x: (e.clientX || e.touches[0].clientX) - containerDimensions.left,
    y: (e.clientY || e.touches[0].clientY) - containerDimensions.top
  };
}
__name(relativeCoords, "relativeCoords");
var Zoom = /* @__PURE__ */ function(_Component) {
  function Zoom2(props) {
    var _this;
    _classCallCheck(this, Zoom2);
    _this = _callSuper(this, Zoom2, [props]);
    _defineProperty(_this, "imageSize", {
      small: {},
      large: {}
    });
    _defineProperty(_this, "tapCount", 0);
    _defineProperty(_this, "containerDimensions", {});
    _defineProperty(_this, "maxAvailableZoom", 1);
    _defineProperty(_this, "largeImgRef", null);
    _defineProperty(_this, "containerRef", null);
    _defineProperty(_this, "zoomAreaRef", null);
    _defineProperty(_this, "zoomMapWrapperRef", null);
    _defineProperty(_this, "zoomMapRef", null);
    _defineProperty(_this, "zoomSVGRef", null);
    _defineProperty(_this, "zoomSVGMaskRef", null);
    _defineProperty(_this, "zoomedImageContainerRef", null);
    _defineProperty(_this, "handleImageLoad", function(type) {
      return function(event) {
        var _event$target = event.target, width = _event$target.width, height = _event$target.height;
        var _ref = _this.props.maxSize || {}, maxAvailableWidth = _ref.width;
        _this.imageSize[type] = {
          width,
          height
        };
        if (_this.imageSize.small && _this.imageSize.small.width && maxAvailableWidth) {
          var maxCalcZoom = maxAvailableWidth / _this.imageSize.small.width;
          _this.maxAvailableZoom = maxCalcZoom >= _this.props.maxZoom ? _this.props.maxZoom : maxCalcZoom;
        }
        _this.setState(_objectSpread({
          disableZoom: !!(_this.maxAvailableZoom <= _this.props.minZoom)
        }, type === "large" ? {
          zoomedImageLoading: false
        } : {}));
      };
    });
    _this.maskId = Math.random().toString(36).substring(2);
    _this.bindMethods();
    _this.maxAvailableZoom = _this.props.maxZoom;
    _this.state = {
      zoomLevel: _this.props.initialZoom,
      disableZoom: true,
      zoomedImageLoading: true
    };
    _this.smallImgRef = /* @__PURE__ */ React.createRef();
    return _this;
  }
  __name(Zoom2, "Zoom");
  _inherits(Zoom2, _Component);
  return _createClass(Zoom2, [{
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function componentDidUpdate() {
      if (this.state.zoomLevel !== this.props.initialZoom) {
        document.addEventListener("touchmove", disablePageTouchMove, {
          passive: false,
          capture: true
        });
      } else {
        document.removeEventListener("touchmove", disablePageTouchMove, {
          passive: false,
          capture: true
        });
      }
    }, "componentDidUpdate")
    /**
     * componentWillUnmount
     */
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function componentWillUnmount() {
      document.removeEventListener("touchmove", disablePageTouchMove, {
        passive: false,
        capture: true
      });
    }, "componentWillUnmount")
    /**
     * setContainerRef
     * @param {Object} ref
     * @returns {void}
     */
  }, {
    key: "setContainerRef",
    value: /* @__PURE__ */ __name(function setContainerRef(ref) {
      this.containerRef = ref;
    }, "setContainerRef")
    /**
     * setLargeImgRef
     * @param {Object} ref
     * @returns {void}
     */
  }, {
    key: "setLargeImgRef",
    value: /* @__PURE__ */ __name(function setLargeImgRef(ref) {
      this.largeImgRef = ref;
    }, "setLargeImgRef")
    /**
     * setZoomMapWrapperRef
     * @param {Object} ref
     * @returns {void}
     */
  }, {
    key: "setZoomMapWrapperRef",
    value: /* @__PURE__ */ __name(function setZoomMapWrapperRef(ref) {
      this.zoomMapWrapperRef = ref;
    }, "setZoomMapWrapperRef")
    /**
     * setZoomMapRef
     * @param {Object} ref
     * @returns {void}
     */
  }, {
    key: "setZoomMapRef",
    value: /* @__PURE__ */ __name(function setZoomMapRef(ref) {
      this.zoomMapRef = ref;
    }, "setZoomMapRef")
    /**
     * setZoomAreaRef
     * @param {Object} ref
     * @returns {void}
     */
  }, {
    key: "setZoomAreaRef",
    value: /* @__PURE__ */ __name(function setZoomAreaRef(ref) {
      this.zoomAreaRef = ref;
    }, "setZoomAreaRef")
    /**
     * setZoomSVGRef
     * @param {Object} ref
     * @returns {void}
     */
  }, {
    key: "setZoomSVGRef",
    value: /* @__PURE__ */ __name(function setZoomSVGRef(ref) {
      this.zoomSVGRef = ref;
    }, "setZoomSVGRef")
    /**
     * setZoomSVGMaskRef
     * @param {Object} ref
     * @returns {void}
     */
  }, {
    key: "setZoomSVGMaskRef",
    value: /* @__PURE__ */ __name(function setZoomSVGMaskRef(ref) {
      this.zoomSVGMaskRef = ref;
    }, "setZoomSVGMaskRef")
    /**
     * setZoomedImageContainerRef
     * @param {Object} ref
     * @returns {void}
     */
  }, {
    key: "setZoomedImageContainerRef",
    value: /* @__PURE__ */ __name(function setZoomedImageContainerRef(ref) {
      this.zoomedImageContainerRef = ref;
    }, "setZoomedImageContainerRef")
  }, {
    key: "handleImageError",
    value: (
      /**
       * handleImageError
       *
       */
      /* @__PURE__ */ __name(function handleImageError() {
        this.setState({
          zoomLevel: this.props.initialZoom,
          zoomedImageLoading: false
        });
      }, "handleImageError")
    )
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleClick = this.handleClick.bind(this);
      this.handleImageLoad = this.handleImageLoad.bind(this);
      this.handleImageError = this.handleImageError.bind(this);
      this.handleMouseMove = this.handleMouseMove.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.toggleZoomLevel = this.toggleZoomLevel.bind(this);
      this.setLargeImgRef = this.setLargeImgRef.bind(this);
      this.setContainerRef = this.setContainerRef.bind(this);
      this.setZoomAreaRef = this.setZoomAreaRef.bind(this);
      this.setZoomMapWrapperRef = this.setZoomMapWrapperRef.bind(this);
      this.setZoomMapRef = this.setZoomMapRef.bind(this);
      this.setZoomSVGRef = this.setZoomSVGRef.bind(this);
      this.setZoomSVGMaskRef = this.setZoomSVGMaskRef.bind(this);
      this.setZoomedImageContainerRef = this.setZoomedImageContainerRef.bind(this);
    }, "bindMethods")
    /**
     * calcUISizes
     * Calculates the UI sizes of all elements in the zoom component based on the small image size
     *
     * @returns {void}
     */
  }, {
    key: "calcUISizes",
    value: /* @__PURE__ */ __name(function calcUISizes() {
      var BORDER_SIZE = parseInt(zoomBorderSize, 10);
      var zoomLevel = this.state.zoomLevel;
      var _this$imageSize$small = this.imageSize.small, width = _this$imageSize$small.width, height = _this$imageSize$small.height;
      this.containerDimensions = this.smallImgRef.current.getBoundingClientRect();
      this.zoomedImageContainerRef.style.top = "".concat(this.smallImgRef.current.offsetTop + BORDER_SIZE, "px");
      this.zoomedImageContainerRef.style.left = "".concat(this.smallImgRef.current.offsetLeft + BORDER_SIZE, "px");
      this.zoomedImageContainerRef.style.width = "".concat(width, "px");
      this.zoomedImageContainerRef.style.height = "".concat(height, "px");
      this.zoomMapWrapperRef.style.top = "".concat(this.smallImgRef.current.offsetTop + ZOOM_MAP_OFFSET_CORRECTION, "px");
      this.zoomAreaRef.style.width = "".concat(width / zoomLevel, "px");
      this.zoomAreaRef.style.height = "".concat(height / zoomLevel, "px");
      if (this.zoomMapRef) {
        var mapDimensions = {
          width: width / ZOOM_MAP_SCALE,
          height: height / ZOOM_MAP_SCALE
        };
        var zoomMapAreaDimensions = {
          width: mapDimensions.width / zoomLevel,
          height: mapDimensions.height / zoomLevel
        };
        this.zoomMapRef.style.width = "".concat(mapDimensions.width, "px");
        this.zoomMapRef.style.height = "".concat(mapDimensions.height, "px");
        this.zoomSVGRef.setAttribute("width", "".concat(mapDimensions.width, "px"));
        this.zoomSVGRef.setAttribute("height", "".concat(mapDimensions.height, "px"));
        this.zoomSVGMaskRef.setAttribute("width", "".concat(zoomMapAreaDimensions.width, "px"));
        this.zoomSVGMaskRef.setAttribute("height", "".concat(zoomMapAreaDimensions.height, "px"));
      }
    }, "calcUISizes")
    /**
     * toggleZoomLevel
     * Toggles the zoom level based on initial zoom, zoom step and max zoom
     *
     * @param {Object} event
     * @returns {void}
     */
  }, {
    key: "toggleZoomLevel",
    value: /* @__PURE__ */ __name(function toggleZoomLevel(event) {
      var _this2 = this;
      var zoomLevel = this.state.zoomLevel;
      var _this$props = this.props, initialZoom = _this$props.initialZoom, zoomStep = _this$props.zoomStep;
      var newZoomLevel = zoomLevel === this.maxAvailableZoom ? initialZoom : zoomLevel + zoomStep;
      if (newZoomLevel > initialZoom && newZoomLevel > this.maxAvailableZoom) {
        newZoomLevel = this.maxAvailableZoom;
      }
      this.setState({
        zoomLevel: newZoomLevel
      }, function() {
        if (newZoomLevel !== initialZoom) {
          _this2.calcUISizes();
          _this2.calcZoomUIState(event);
        }
      });
    }, "toggleZoomLevel")
    /**
     * calcZoomUIState
     * do all calculations when in zoom level mode: mask positions, zoom area, large image position
     *
     * @param {Object} event
     * @returns {void}
     */
  }, {
    key: "calcZoomUIState",
    value: /* @__PURE__ */ __name(function calcZoomUIState(event) {
      var zoomLevel = this.state.zoomLevel;
      var _this$imageSize$small2 = this.imageSize.small, smallImgWidth = _this$imageSize$small2.width, smallImgHeight = _this$imageSize$small2.height;
      if (zoomLevel === this.props.initialZoom) {
        return;
      }
      var coords = relativeCoords(event, this.containerDimensions);
      var zoomAreaCoords = {
        top: coords.y - this.zoomAreaRef.offsetHeight / 2,
        left: coords.x - this.zoomAreaRef.offsetWidth / 2
      };
      zoomAreaCoords.top = zoomAreaCoords.top < 0 ? 0 : zoomAreaCoords.top;
      zoomAreaCoords.left = zoomAreaCoords.left < 0 ? 0 : zoomAreaCoords.left;
      zoomAreaCoords.bottom = zoomAreaCoords.top + this.zoomAreaRef.offsetHeight;
      zoomAreaCoords.right = zoomAreaCoords.left + this.zoomAreaRef.offsetWidth;
      if (zoomAreaCoords.bottom > smallImgHeight) {
        zoomAreaCoords.top = smallImgHeight - this.zoomAreaRef.offsetHeight;
      }
      if (zoomAreaCoords.right > smallImgWidth) {
        zoomAreaCoords.left = smallImgWidth - this.zoomAreaRef.offsetWidth;
      }
      this.zoomAreaRef.style.top = "".concat(zoomAreaCoords.top, "px");
      this.zoomAreaRef.style.left = "".concat(zoomAreaCoords.left, "px");
      this.largeImgRef.style.top = "".concat(-zoomAreaCoords.top * zoomLevel, "px");
      this.largeImgRef.style.left = "".concat(-zoomAreaCoords.left * zoomLevel, "px");
      if (this.zoomMapRef) {
        var zoomMapCoords = {
          top: "".concat(zoomAreaCoords.top / ZOOM_MAP_SCALE, "px"),
          left: "".concat(zoomAreaCoords.left / ZOOM_MAP_SCALE, "px")
        };
        this.zoomSVGMaskRef.setAttribute("y", zoomMapCoords.top);
        this.zoomSVGMaskRef.setAttribute("x", zoomMapCoords.left);
      }
    }, "calcZoomUIState")
    /**
     * handleClick
     * @param {Object} event
     * @returns {void}
     */
  }, {
    key: "handleClick",
    value: /* @__PURE__ */ __name(function handleClick(event) {
      if (event.defaultPrevented !== true) {
        event.preventDefault();
      }
      this.toggleZoomLevel(event);
    }, "handleClick")
    /**
     * handleMouseMove
     * @param {Object} event
     * @returns {void}
     */
  }, {
    key: "handleMouseMove",
    value: /* @__PURE__ */ __name(function handleMouseMove(event) {
      this.calcZoomUIState(event);
    }, "handleMouseMove")
    /**
     * handleTouchStart
     * @param {Object} event
     * @returns {void}
     */
  }, {
    key: "handleTouchStart",
    value: /* @__PURE__ */ __name(function handleTouchStart(event) {
      var _this3 = this;
      if (event.defaultPrevented !== true) {
        event.preventDefault();
      }
      if (this.tapCount === 2) {
        return;
      }
      this.tapCount += 1;
      if (this.tapCount >= 2) {
        this.toggleZoomLevel(event);
      } else {
        setTimeout(function() {
          _this3.tapCount = 0;
        }, 500);
      }
    }, "handleTouchStart")
    /**
     * handleTouchMove
     * @param {Object} event
     * @returns {void}
     */
  }, {
    key: "handleTouchMove",
    value: /* @__PURE__ */ __name(function handleTouchMove(event) {
      if (event.defaultPrevented !== true) {
        event.preventDefault();
      }
      if (this.state.zoomLevel !== this.props.initialZoom) {
        this.calcZoomUIState(event);
      }
    }, "handleTouchMove")
    /**
     * render
     *
     * @returns {React.Element}
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$props2 = this.props, className = _this$props2.className, showZoomedArea = _this$props2.showZoomedArea, showMap = _this$props2.showMap, smallImage = _this$props2.smallImage, largeImage = _this$props2.largeImage, initialZoom = _this$props2.initialZoom;
      var _this$state = this.state, zoomLevel = _this$state.zoomLevel, disableZoom = _this$state.disableZoom;
      var isZoomed = zoomLevel !== initialZoom;
      var containerHandlers = !disableZoom ? {
        onClick: this.handleClick,
        onMouseMove: this.handleMouseMove,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove
      } : {};
      return /* @__PURE__ */ React.createElement("div", {
        className: classnames(zoomCls, className)
      }, /* @__PURE__ */ React.createElement("div", _extends({
        ref: this.setContainerRef,
        className: classnames(zoomContainerCls, _defineProperty(_defineProperty({}, zoomContainerDisableCls, disableZoom), zoomContainerZoomedCls, isZoomed))
      }, containerHandlers), /* @__PURE__ */ React.createElement(Picture, _objectSpread(_objectSpread({}, smallImage), {}, {
        imgProps: _objectSpread(_objectSpread({}, smallImage.imgProps), {}, {
          ref: this.smallImgRef,
          className: zoomSmallImgCls,
          onLoad: this.handleImageLoad("small"),
          onError: this.handleImageError
        })
      })), isZoomed && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
        ref: this.setZoomAreaRef,
        className: classnames(zoomAreaCls, _defineProperty({}, zoomAreaVisibleCls, showZoomedArea))
      }), /* @__PURE__ */ React.createElement("div", {
        ref: this.setZoomedImageContainerRef,
        className: zoomLargeImageContainerCls
      }, this.state.zoomedImageLoading ? /* @__PURE__ */ React.createElement(PreloaderRipple, {
        isActive: true
      }, "\xA0") : null, /* @__PURE__ */ React.createElement("picture", {
        className: largeImage.className
      }, largeImage.srcSet.webp ? /* @__PURE__ */ React.createElement("source", {
        type: "image/webp",
        srcSet: largeImage.srcSet.webp,
        sizes: largeImage.sizes
      }) : null, /* @__PURE__ */ React.createElement("img", _extends({
        src: largeImage.src,
        srcSet: largeImage.srcSet.img,
        sizes: largeImage.sizes,
        alt: largeImage.alt
      }, largeImage.imgProps, {
        ref: this.setLargeImgRef,
        className: classnames(zoomLargeImgCls, _defineProperty({}, zoomLargeImgVisibleCls, isZoomed)),
        onLoad: this.handleImageLoad("large"),
        onError: this.handleImageError,
        style: {
          width: this.imageSize.small.width * zoomLevel
        }
      }))))), showMap && isZoomed && /* @__PURE__ */ React.createElement("div", {
        className: zoomMapCls,
        ref: this.setZoomMapWrapperRef
      }, /* @__PURE__ */ React.createElement("div", {
        className: zoomMapInnerCls,
        ref: this.setZoomMapRef
      }, /* @__PURE__ */ React.createElement(Picture, _objectSpread(_objectSpread({}, smallImage), {}, {
        imgProps: _objectSpread(_objectSpread({}, smallImage.imgProps), {}, {
          className: zoomMapImageCls
        })
      })), /* @__PURE__ */ React.createElement("svg", {
        ref: this.setZoomSVGRef,
        className: zoomSVGMaskCls
      }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", {
        id: this.maskId,
        x: "0",
        y: "0",
        width: "100%",
        height: "100%"
      }, /* @__PURE__ */ React.createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: "#fff"
      }), /* @__PURE__ */ React.createElement("rect", {
        ref: this.setZoomSVGMaskRef,
        fill: "#000"
      }))), /* @__PURE__ */ React.createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        mask: "url(#".concat(this.maskId, ")")
      }))))));
    }, "render")
  }]);
}(Component);
_defineProperty(Zoom, "defaultProps", {
  initialZoom: ZOOM_INIT_LEVEL,
  maxZoom: ZOOM_MAX_LEVEL,
  minZoom: ZOOM_MIN_LEVEL,
  zoomStep: ZOOM_LEVEL_STEP,
  maxSize: null,
  className: null,
  showZoomedArea: false,
  showMap: true
});
export {
  Zoom
};
